import { render, staticRenderFns } from "./PrintCase.vue?vue&type=template&id=42f578ca&"
import script from "./PrintCase.vue?vue&type=script&lang=js&"
export * from "./PrintCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrintCase.vue"
export default component.exports